import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../i18n/I18nContext';
import { getStaticPageCopy } from '../i18n/staticPageCopy';
import '../style/Homepage.css';

const routeByPage = {
  about: ['/how-it-works', '/find-teller'],
  health: ['/privacy', '/mental-health'],
  mental: ['/contact?topic=safety', '/security'],
  partnership: ['/contact?topic=partnership', '/onboarding/teller'],
  mobile: ['/login', '/register'],
};

const relatedRouteByPage = {
  about: '/contact', health: '/security', mental: '/help', partnership: '/contact?topic=partnership', mobile: '/how-it-works',
};

const LocalizedStaticPage = ({ page }) => {
  const { language } = useI18n();
  const copy = getStaticPageCopy(language, page);
  const [primaryRoute, secondaryRoute] = routeByPage[page];

  return (
    <div>
      <Header />
      <main className={`info-page terms-page ${page}-page`}>
        <section className="info-hero terms-hero">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h1>{copy.title}</h1>
          <p>{copy.description}</p>
          <div className="hero-actions">
            <Link className="primary-button" to={primaryRoute}>{copy.primary}</Link>
            <Link className="secondary-button" to={secondaryRoute}>{copy.secondary}</Link>
          </div>
        </section>

        <section className="feature-grid info-grid terms-summary-grid" aria-label={copy.eyebrow}>
          {copy.cards.map(([title, body]) => (
            <article className="feature-card" key={title}><h3>{title}</h3><p>{body}</p></article>
          ))}
        </section>

        <section className="terms-notice">
          <div><p className="eyebrow">{copy.noticeEyebrow}</p><h2>{copy.noticeTitle}</h2></div>
          <p>{copy.noticeBody}</p>
        </section>

        <section className="terms-content" aria-label={copy.title}>
          {copy.sections.map(([title, paragraphs]) => (
            <article className="terms-section-card" key={title}>
              <h2>{title}</h2>
              <div>{paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
            </article>
          ))}
        </section>

        <section className="terms-contact-card">
          <div><p className="eyebrow">{copy.related}</p><h2>{copy.relatedTitle}</h2></div>
          <p>{copy.relatedBody} <Link to={relatedRouteByPage[page]}>{copy.primary}</Link></p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LocalizedStaticPage;
